// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"53489604","355":"d844c44e","358":"4c219241","478":"ab9b1a2d","640":"0d393154","828":"5107eaff"}[chunkId] + ".chunk.js";
};